import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '../views/Home.vue';
import CalculateTabs from '../views/CalculateTabs.vue';
import CalculateTabsBri from '../views/CalculateTabsBri.vue';
import PhotoBooth from "@/views/PhotoBooth.vue";
import PhotoBoothPawRents from "@/views/PhotoBoothPawRents.vue";


import SpinWheel from "@/views/SpinWheel.vue";


import CalculatePopup from '../views/CalculatePopup.vue';



Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'calculate',
    component: CalculateTabs,
  },
  {
    path: '/bri',
    name: 'calculate bri',
    component: CalculateTabsBri,
  },
  {
    path: '/popup/:value',
    name: 'calculate popup',
    props: true,
    component: CalculatePopup,
  },
  {
    path: "/photo-booth",
    name: 'PhotoBooth',
    props: true,
    component: PhotoBooth,
  },
  {
    path: "/spin",
    name: 'SpinWheel',
    props: true,
    component: SpinWheel,
  },
  {
    path: "/photo-booth-pawrents",
    name: 'PhotoBoothPawRents',
    props: true,
    component: PhotoBoothPawRents,
  }
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
